export default "__VITE_ASSET__506b5f30__"